import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { promotedRecordQuery } from './PromotedRecordQuery';

export class PromotedRecordStatusName extends Field {
  static subqueriesForModel() {
    return {
      promotable: promotedRecordQuery(),
    };
  }

  get title() {
    return 'Promoted to record status name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Under consideration' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.promotable?.workflowStatus) {
      return {
        text: record.promotable.workflowStatus.name,
      };
    }

    return {};
  }
}
